import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './lets-link-contact.module.css';

import apple from '../../public/letslink/contact/apple.png';
import play from '../../public/letslink/contact/play.png';
import {
  Container,
  FormContactLetslink,
  Htag,
  HtagAlign,
  HtagVariant,
} from '../../components';

export interface LetsLinkContactProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkContact({
  className,
  ...props
}: LetsLinkContactProps) {
  return (
    <section className={cn(className, styles.contact)} {...props}>
      <Container variant="container_small">
        <AnimationOnScroll
          delay={0}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Htag
            tag="h4"
            align={HtagAlign.center}
            variant={HtagVariant.h4}
            className={styles.contact_title}
          >
            linkapp available now
          </Htag>
        </AnimationOnScroll>

        <AnimationOnScroll
          delay={0}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <div className={styles.contact_links}>
            <a
              href="https://apps.apple.com/us/app/linkapp-new-friends-events/id1563954700?ign-itsct=apps_box_link&ign-itscg=30200"
              target="_blank"
              rel="noreferrer"
              className={styles.apple}
            >
              <Image alt="app store" src={apple} width={367} height={109} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://play.google.com/store/apps/details?id=mobile.app.linkapp "
            >
              <Image alt="play market" src={play} width={367} height={109} />
            </a>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          delay={0}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeIn"
        >
          <FormContactLetslink />
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
